module.exports = __webpack_public_path__ + "img/icon-hour-glass.73896a79.svg";